module.exports = "../images/icon-fishing.svg?v=e8217e9";